import React from 'react'
import { Show, TextField, DateField } from '@refinedev/antd'
import { useShow, useOne } from '@refinedev/core'
import { Typography, Tag } from 'antd'
import type { Tables } from '@muaa/shared'

type UserSetting = Tables<'user_settings'>
type Profile = Tables<'profiles'>

const { Title } = Typography

const BoolTag = ({ value }: { value: boolean | undefined }) =>
  value != null ? (
    <Tag color={value ? 'green' : 'default'}>{value ? 'On' : 'Off'}</Tag>
  ) : (
    <TextField value="—" />
  )

export function UserSettingShow() {
  const { query } = useShow<UserSetting>({
    meta: { idColumnName: 'user_id' },
  })
  const isLoading = query.isLoading
  const record = query.data?.data

  const { query: profileQuery } = useOne<Profile>({
    resource: 'profiles',
    id: record?.user_id ?? '',
    meta: { idColumnName: 'user_id' },
    queryOptions: { enabled: !!record?.user_id },
  })

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Member</Title>
      <TextField value={profileQuery.data?.data?.name ?? record?.user_id ?? '—'} />

      <Title level={5}>Language</Title>
      <TextField value={record?.language ?? '—'} />

      <Title level={5}>Push Notifications</Title>
      <BoolTag value={record?.push} />

      <Title level={5}>Digest</Title>
      <BoolTag value={record?.digest} />

      <Title level={5}>Reminders</Title>
      <BoolTag value={record?.reminders} />

      <Title level={5}>Photos</Title>
      <BoolTag value={record?.photos} />

      <Title level={5}>Directory</Title>
      <BoolTag value={record?.directory} />

      <Title level={5}>Face ID</Title>
      <BoolTag value={record?.faceid} />

      <Title level={5}>Updated</Title>
      {record?.updated_at ? (
        <DateField value={record.updated_at} format="MMM D, YYYY h:mm A" />
      ) : (
        <TextField value="—" />
      )}
    </Show>
  )
}
